import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  GET_DOWNSIZE_INFO_BY_ACCOUNT,
  GET_DOWNSIZE_INFO_BY_ACCOUNT_SUCCESS,
  GET_DOWNSIZE_INFO_BY_ACCOUNT_FAIL,
] = createRequestConstantNames(cc('GET_DOWNSIZE_INFO_BY_ACCOUNT'));
